import { MenuValidationsType } from '../../constants/Navigation'

type ValidationMethod = 'flags' | 'roles'

class PermissionHelper {
  checkCountry(country: string, countries: string[]) {
    return countries?.includes?.(country)
  }

  checkFeatureFlag(flag: string, flags: string[]) {
    return flags?.includes?.(flag)
  }

  checkUserRole(role: string, userRole: string) {
    return userRole === role
  }

  countries(countries: string[], _: string, validations: MenuValidationsType) {
    return validations?.countries?.every(country => this.checkFeatureFlag(country, countries))
  }

  flags(enabledFeatures: string[], _: string, validations: MenuValidationsType) {
    return validations?.flags?.every(flag => this.checkFeatureFlag(flag, enabledFeatures))
  }

  roles(_: string[], userRole: string, validations: MenuValidationsType) {
    return validations?.roles?.every(role => this.checkUserRole(role, userRole))
  }

  check(enabledFeatures: string[], userRole: string, validations: MenuValidationsType) {
    return Object.keys(validations).every(key =>
      this[key as ValidationMethod](enabledFeatures, userRole, validations)
    )
  }

  checkSideBar(enabledFeatures: string[], permissions: MenuValidationsType) {
    return Object.keys(permissions).every(key =>
      this[key as ValidationMethod](enabledFeatures, '', permissions)
    )
  }
}

export default new PermissionHelper()
